import { Component, Element,  State, h, Host, Method, Listen, Prop } from '@stencil/core';

@Component({
  tag: 'zpr-tabs-vertical'
})


export class ZprTabsVertical {
  private _indicator: HTMLElement;
  @Element() el: HTMLElement;
  @Prop() hasBgIndicator: boolean = false;

  componentDidLoad(){
    let childSlot = Array.from(this.el.children);
    let children = childSlot[0].querySelectorAll('zpr-tab')
    let activeElement:HTMLZprTabElement;

    for(let child of children){
      if(child.active == true){
        activeElement = child;
        continue;
      }
    }
    this.positionIndicator(activeElement)
  }

  @Listen('tabChange')
  onTabChanged(ev:CustomEvent){
    this.positionIndicator(ev.detail.tab as Element)
  }

  positionIndicator(el:Element){
    let header = el.getElementsByTagName('header')[0];
    let position;
    if (this.hasBgIndicator) {
      let headerHeight = header.offsetHeight;
      const indicatorHeight = 10;
      position = headerHeight ? (header.offsetTop + headerHeight/2 - indicatorHeight) : 30;
    } else {
      position = header.offsetTop + 30;
    }
    this._indicator.style.top = `${position }px`;
  }

  render() {
    return (
      <Host>
        <slot name="tabs"></slot>
        <slot name="actions"></slot>
        <div class="indicator-pane">
          <div class="indicator" ref={el => this._indicator = el}>
            <span class="indicator-arrow"></span>
            <span class="indicator-cover"></span>
          </div>
        </div>
      </Host>
    )
  }
}